module.exports = __webpack_public_path__ + "img/logo-3.e4bb699f.png";